// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollToTopButton_scrollButton__9wIN8"};